import focusLock from 'dom-focus-lock';

import './modal.scss';

const state = {
  activeModal: null,
  previousFocus: null,
};

const template = function modalTemplate({
  content,
  id,
  modifier,
  title,
}) {
  return `<div class="modal${modifier ? ` modal--${modifier}` : ''}" id="${id}" aria-hidden="true">
    <div class="modal__content">
      <div class="modal__el">
        <h3 class="modal__title js-modalHeading" tabindex="-1">
          ${title}
        </h3>
        <div class="modal__el__content">
          ${content}
        </div>
        <button class="modal__close js-modalClose" data-id="${id}">
          <span class="visually-hidden">Close</span>
        </button>
      </div>
    </div>
    <div class="modal__bg js-modalClose" data-id="${id}"></div>
  </div>`;
};

const close = function closeModal(id, options = {}) {
  const el = document.getElementById(id);
  if (!el) {
    return;
  }
  el.setAttribute('aria-hidden', 'true');
  focusLock.off(el);
  state.activeModal = null;

  if (options.shouldSkipFocus) {
    return;
  }

  const toggleEl = document.querySelector(`.js-modalToggle[data-id="${id}"]`);
  if (toggleEl) {
    toggleEl.focus();
  } else if (state.previousFocus) {
    state.previousFocus.focus();
  }
};

const open = function openModal(id) {
  const el = document.getElementById(id);
  if (!el) {
    return;
  }

  state.previousFocus = document.activeElement;
  el.setAttribute('aria-hidden', 'false');
  state.activeModal = id;

  setTimeout(() => {
    focusLock.on(el);
    el.querySelector('.js-modalHeading').focus({ preventScroll: true });
  }, 400);
};

const toggle = function toggleModal(id) {
  const isOpen = document.getElementById(id).getAttribute('aria-hidden') === 'false';

  if (isOpen) {
    close(id);
  } else {
    open(id);
  }
};

const onCloseClick = function onModalCloseClick(ev) {
  const el = ev.currentTarget;
  const id = el.getAttribute('data-id');

  close(id);
};

const onToggleClick = function onModalToggleClick(ev) {
  const el = ev.currentTarget;
  const id = el.getAttribute('data-id');

  toggle(id);
};

const unbind = function unbindModal() {
  [].forEach.call(
    document.querySelectorAll('.js-modalToggle'),
    (el) => {
      el.removeEventListener('click', onToggleClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-modalClose'),
    (el) => {
      el.removeEventListener('click', onCloseClick);
    },
  );
};

const bind = function bindModal() {
  [].forEach.call(
    document.querySelectorAll('.js-modalToggle'),
    (el) => {
      el.addEventListener('click', onToggleClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-modalClose'),
    (el) => {
      el.addEventListener('click', onCloseClick);
    },
  );
};

const destroy = function destroyModal() {
  if (state.activeModal) {
    close(state.activeModal, { shouldSkipFocus: true });
  }

  unbind();
};

const init = function initModal() {
  unbind();
  bind();
};

const remove = function removeModal(id) {
  const el = document.getElementById(id);
  if (el) {
    el.parentNode.removeChild(el);
  }
};

const render = function renderModal({
  content,
  id,
  modifier,
  title,
}) {
  // Make sure duplicates aren't rendered
  remove(id);

  document.body.insertAdjacentHTML(
    'beforeend',
    template({
      content,
      modifier,
      id,
      title,
    }),
  );

  unbind();
  bind();
};

export default {
  close,
  destroy,
  init,
  open,
  render,
};
